import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

const {
  primaryColours,
  grid: { spacing, resolution },
  tints,
  borderRadius,
} = theme

export const ExplainerStepStyles = styled.div<{ isCurrent: boolean }>`
  .step-wrapper {
    display: flex;
    gap: ${spacing.s}px;
    padding: ${spacing.s}px ${spacing.xs}px;
    border-radius: ${borderRadius.main};

    .text {
      margin: ${spacing.s}px 0;
      color: ${primaryColours.aubergine.main};
    }

    .button {
      height: 48px;
      padding: ${spacing.xs}px ${spacing.base}px;
    }

    .button__secondary {
      background-color: white;
    }

    .button-tablet {
      display: none;
    }

    ${({ isCurrent }) => !isCurrent && 'display: none'};
  }

  .button-mobile {
    ${({ isCurrent }) => !isCurrent && 'display: none'};
  }

  @media (min-width: ${resolution.tablet.width}px) {
    .button-mobile {
      display: none;
    }
    .step-wrapper {
      ${({ isCurrent }) => !isCurrent && 'display: flex'};
      ${({ isCurrent }) => isCurrent && `background-color: ${tints.lightAubergine};`}
      .button-tablet {
        display: flex;
      }
    }
  }
`
